import { render } from "./VTable.vue?vue&type=template&id=17fd88e0&scoped=true"
import script from "./VTable.vue?vue&type=script&lang=js"
export * from "./VTable.vue?vue&type=script&lang=js"

import "./VTable.vue?vue&type=style&index=0&id=17fd88e0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fd88e0"]])

export default __exports__